<template>
  <section class="layout bg-middle">
    <multiple-columns class="layout-span-2"/>
    <scrollable-card />
    <progress-dual-card v-if="false"/>
    <progress-card v-if="false"/>
    <h-progress-card v-if="false"/>
    <donut-card v-if="false"/>
    <v-stack-line-plot-card />
    <line-card />
    <h-bars-plot-card v-if="false"/>
    <pie-card v-if="false"/>
    <h-bars-card v-if="false" />
  </section>
</template>

<script>
import MultipleColumns from '@/components/charts/dev/plot/MultipleColumns.vue'
import ScrollableCard from '@/components/charts/dev/plot/ScrollableCard.vue'
import VStackLinePlotCard from '@/components/charts/dev/plot/VStackLineCard.vue'
import HBarsPlotCard from '@/components/charts/dev/plot/HBarsCard.vue'
import LineCard from '@/components/charts/dev/plot/LineCard.vue'
import DonutCard from '@/components/charts/dev/DonutCard.vue'
import PieCard from '@/components/charts/dev/PieCard.vue'
import HBarsCard from '@/components/charts/dev/HBarsCard.vue'
import HProgressCard from '@/components/charts/dev/HProgressCard.vue'
import ProgressCard from '@/components/charts/dev/ProgressCard.vue'
import ProgressDualCard from '@/components/charts/dev/ProgressDualCard.vue'

export default {
  layout: 'private',
  components: {
    MultipleColumns,
    ScrollableCard,
    DonutCard,
    VStackLinePlotCard,
    LineCard,
    HBarsPlotCard,
    PieCard,
    HBarsCard,
    HProgressCard,
    ProgressCard,
    ProgressDualCard
  },
  head () {
    return {
      title: 'Dashboard',
      meta: [{
        requiresAuth: true,
        hid: 'description',
        name: 'description',
        content: 'This is content of Dashboard page'
      }]
    }
  }
}
</script>

<style lang="scss" scoped>
.layout {
  display: grid;
  grid-template-columns: auto auto;
  grid-template-rows: auto;
  grid-gap: 1rem;
  padding: .25rem;
  &-span-2 {
    grid-column: 1 / span 2;
  }
}
@media only screen and (min-width: 30em) and (max-width: 80em) {
  .layout {
    padding: .5rem;
  }
}
@media screen and (min-width: 80em) {
  .layout {
    padding: 1rem;
  }
}
</style>
